import * as React from 'react';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkSpacing } from 'uitk-react-spacing';
import { IconMark } from '../icon-mark';
var FreeCancellationBannerMedia = function (_a) {
  var icon = _a.icon,
    graphic = _a.graphic;
  return React.createElement(UitkSpacing, null, React.createElement("div", null, React.createElement(UitkSpacing, {
    padding: {
      inline: 'six'
    }
  }, React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R1_1,
    imageFit: "contain"
  }, React.createElement(UitkImage, {
    src: (icon === null || icon === void 0 ? void 0 : icon.id) || (graphic === null || graphic === void 0 ? void 0 : graphic.url)
  })))));
};
export var BannerMedia = function (_a) {
  var icon = _a.icon,
    mark = _a.mark,
    graphic = _a.graphic;
  var canRenderMedia = icon || mark || graphic;
  if (!canRenderMedia) {
    return null;
  }
  if ((icon === null || icon === void 0 ? void 0 : icon.description) === 'bex' || (graphic === null || graphic === void 0 ? void 0 : graphic.url)) {
    return React.createElement(FreeCancellationBannerMedia, {
      icon: icon,
      graphic: graphic
    });
  }
  var renderIconBackground = (icon === null || icon === void 0 ? void 0 : icon.withBackground) || false;
  var renderedMediaType = mark ? 'mark' : 'icon';
  return React.createElement(UitkSpacing, {
    margin: {
      inline: "".concat(renderIconBackground ? 'unset' : 'two'),
      block: "".concat(mark ? 'one' : 'unset')
    }
  }, React.createElement("div", {
    "data-testid": "banner-media-".concat(renderedMediaType)
  }, React.createElement(IconMark, {
    mark: mark,
    icon: icon,
    withBackground: renderIconBackground
  })));
};